import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { uiState } from "../../interfaces/uiState";

export interface UiState {
  uiState: uiState;
}

const initialState: UiState = {
  uiState: {
    showNavbar: true,
    showFriends: true,
    showInitialLoadPopup:
      localStorage.getItem("isShowInitialPopup") !== "false",
  },
};

const uiSlice = createSlice({
  name: "userReducer",
  initialState,
  reducers: {
    setShowNavbar: (state, action: PayloadAction<boolean>) => {
      state.uiState.showNavbar = action.payload;
    },
    setShowFriends: (state, action: PayloadAction<boolean>) => {
      state.uiState.showFriends = action.payload;
    },
    hideInitialLoadPopup: (state) => {
      state.uiState.showInitialLoadPopup = false;
    },
  },
});

export const { setShowNavbar, setShowFriends, hideInitialLoadPopup } =
  uiSlice.actions;
export default uiSlice.reducer;
